import { useEffect } from "react";
import { analytics } from "../firebase/firebase";
import { logEvent } from "firebase/analytics";

const useHandleError = () => {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      console.error("Frontend Error:", event.error);

      logEvent(analytics, "exception", {
        description: event.error?.message || "Unknown Error",
        fatal: true,
      });
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error("Unhandled Promise Rejection:", event.reason);

      logEvent(analytics, "exception", {
        description: event.reason?.message || "Unhandled Promise Rejection",
        fatal: true,
      });
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
    };
  }, []);
};

export default useHandleError;
